import { useUiPreferences } from '../useUiPreferences';
import { ActionRow, Section, SegmentedRow, TextRow, ToggleRow } from '../SettingsRows';

const DEFAULTS = {
    'ui.email.enabled': 'true',
    'ui.email.smtp_host': '',
    'ui.email.smtp_port': '587',
    'ui.email.encryption': 'STARTTLS',
    'ui.email.username': '',
    'ui.email.from_address': '',
    'ui.email.invite_emails': 'true',
};

export function EmailTab(): React.JSX.Element {
    const [prefs, save] = useUiPreferences(DEFAULTS);

    return (
        <>
            <Section title="Server">
                <ToggleRow
                    label="Send email"
                    desc="Turn off to disable every outgoing message."
                    value={prefs['ui.email.enabled'] === 'true'}
                    onChange={(v) => save({ 'ui.email.enabled': String(v) })}
                />
                <TextRow
                    label="SMTP host"
                    desc="Hostname of your mail relay."
                    value={prefs['ui.email.smtp_host']}
                    onChange={(v) => save({ 'ui.email.smtp_host': v })}
                    placeholder="smtp.home.lan"
                />
                <TextRow
                    label="Port"
                    desc="587 for STARTTLS, 465 for implicit TLS."
                    value={prefs['ui.email.smtp_port']}
                    onChange={(v) => save({ 'ui.email.smtp_port': v })}
                />
                <SegmentedRow
                    label="Encryption"
                    desc="How the connection is secured."
                    options={['STARTTLS', 'SSL/TLS', 'None']}
                    value={prefs['ui.email.encryption']}
                    onChange={(v) => save({ 'ui.email.encryption': v })}
                />
            </Section>
            <Section title="Credentials">
                <TextRow
                    label="Username"
                    desc="Leave empty for an open relay on your LAN."
                    value={prefs['ui.email.username']}
                    onChange={(v) => save({ 'ui.email.username': v })}
                />
                <TextRow
                    label="From address"
                    desc="Shown as the sender on every message."
                    value={prefs['ui.email.from_address']}
                    onChange={(v) => save({ 'ui.email.from_address': v })}
                    placeholder="Musiceer <no-reply@home.lan>"
                />
            </Section>
            <Section title="Messages">
                <ToggleRow
                    label="Invite emails"
                    desc="Send invite codes straight to the address you enter."
                    value={prefs['ui.email.invite_emails'] === 'true'}
                    onChange={(v) => save({ 'ui.email.invite_emails': String(v) })}
                />
                <ActionRow label="Test message" desc="Sends one email to your own address." actionLabel="Send test" tone="solid" />
            </Section>
        </>
    );
}
